import VueLazyload from 'vue-lazyload'
export default VueLazyload



// WEBPACK FOOTER //
// ./src/components/lazyload/index.js